// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"b28a227c3c0ff882145f","532":"6631178a9b97260ce30a","691":"32ce49004f8116adc067"}[chunkId] + ".js";
};